import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ColourSwatchGrid from './ColourSwatchGrid';
import ColourDetailModal from './ColourDetailModal';
import { SAULEDA_COLOURS, STOCK_COLOUR_CODE, TOTAL_COLOURWAYS } from '../data/sauledaColours';
import { COLOUR_LEAD_TIME_NOTE } from '../config/leadTimes';
import './ProductColours.css';

const PREVIEW_COUNT = 12;

// Compact fabric-colour preview for awning product pages: a dozen swatches and
// a way through to the full range. Uses the same grid and detail view as
// /colours, so the two can't drift.
export default function ProductColours() {
  const [selected, setSelected] = useState(null);
  if (SAULEDA_COLOURS.length === 0) return null;

  // Lead with the stocked colourway - it is the one that ships fastest.
  const ordered = [...SAULEDA_COLOURS].sort((a, b) => {
    if (a.code === STOCK_COLOUR_CODE) return -1;
    if (b.code === STOCK_COLOUR_CODE) return 1;
    return 0;
  });
  const preview = ordered.slice(0, PREVIEW_COUNT);

  return (
    <div className="pc-colours">
      <p className="pc-leadtime">{COLOUR_LEAD_TIME_NOTE}</p>

      <ColourSwatchGrid
        colours={preview}
        onSelect={setSelected}
        stockCode={STOCK_COLOUR_CODE}
        compact
      />

      <Link to="/colours" className="pc-viewall">
        View all {TOTAL_COLOURWAYS} colours
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M5 12h14m0 0-6-6m6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Link>

      <ColourDetailModal
        colour={selected}
        onClose={() => setSelected(null)}
        isStock={selected ? selected.code === STOCK_COLOUR_CODE : false}
        stockNote="Held in stock - can often ship the next business day."
      />
    </div>
  );
}
